import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { GoodBase } from './GoodBase';

export class Asset extends GoodBase {
    _originalTypeClassName = "zERP.BO.Asset";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Asset.translate = translateService;
}
super();
this.SubAssets = [];
this.Type = null;
this.DateAcquired = null;
this.DateSold = null;
this.DateDestructed = null;
this.DateDepreciated = null;
this.Quantity = null;
this.UnitPrice = null;
this.PurchaseValue = null;
this.SalvageValue = null;
this.DepreciableValue = null;
this.MarginalSalvageValue = null;
this.DepreciationEndDate = null;
this.IsDepreciable = false;
this.UsefulLife = null;
this.DepreciationDuration = null;
this.Status = null;
this.IsIntegratedWithMainAsset = false;
this.IsExcludedFromAssetRegistry = false;
this.InstitutionalFramework = null;
this.OverrideTaxRate = false;
this.SerialNumber = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
Type:any;
DateAcquired:any;
DateSold:any;
DateDestructed:any;
DateDepreciated:any;
Quantity:any;
UnitPrice:any;
PurchaseValue:any;
SalvageValue:any;
DepreciableValue:any;
MarginalSalvageValue:any;
DepreciationEndDate:any;
IsDepreciable:any;
UsefulLife:any;
DepreciationDuration:any;
Status:any;
IsIntegratedWithMainAsset:any;
IsExcludedFromAssetRegistry:any;
InstitutionalFramework:any;
OverrideTaxRate:any;
SerialNumber:any;
Category:any;
SubAssets:any;
Department:any;
Direction:any;
AccountingDepreciationCategory:any;
TaxDepreciationCategory:any;
Supplier:any;
DepreciationRate:any;
VATRate:any;
TaxValuation:any;
AccountingValuation:any;
AssetLocation:any;
AssetGroup:any;
AssetResponsible:any;
static setCategory = ($this, value) => {
var oldValue = $this.Category;
$this.Category = value;
if (value != null) {
}
}
static setSubAssets = ($this, items) => {
                if (items == null) items = [];
                if ($this.SubAssets == null) $this.SubAssets = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SubAssets.length > 0) {
                    Domain.Asset.removeSubAssets($this, $this.SubAssets[0]);
                }

                Domain.Asset.addManySubAssets($this, copyItems);
            }
static addManySubAssets = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Asset.addSubAssets($this, items[i]);
                }
            }
static addSubAssets = ($this, item) => {
                if ($this.SubAssets == null) $this.SubAssets = [];
                if (item == null || $this.SubAssets.indexOf(item) > -1) return;
                $this.SubAssets.push(item);
}
static addRangeSubAssets = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Asset.addSubAssets($this, item));
            }
static removeSubAssets = ($this, item) => {
                if ($this == null || $this.SubAssets == null || $this.SubAssets.indexOf(item) === -1) return;
                var _index = $this.SubAssets.indexOf(item);
                $this.SubAssets.splice(_index, 1);
}
static clearSubAssets = ($this) => { $this.SubAssets = null; }
static setDepartment = ($this, value) => {
var oldValue = $this.Department;
$this.Department = value;
if (value != null) {
}
}
static setDirection = ($this, value) => {
var oldValue = $this.Direction;
$this.Direction = value;
if (value != null) {
}
}
static setAccountingDepreciationCategory = ($this, value) => {
var oldValue = $this.AccountingDepreciationCategory;
$this.AccountingDepreciationCategory = value;
if (value != null) {
}
}
static setTaxDepreciationCategory = ($this, value) => {
var oldValue = $this.TaxDepreciationCategory;
$this.TaxDepreciationCategory = value;
if (value != null) {
}
}
static setSupplier = ($this, value) => {
var oldValue = $this.Supplier;
$this.Supplier = value;
if (value != null) {
}
}
static setDepreciationRate = ($this, value) => {
var oldValue = $this.DepreciationRate;
$this.DepreciationRate = value;
if (value != null) {
}
}
static setVATRate = ($this, value) => {
var oldValue = $this.VATRate;
$this.VATRate = value;
if (value != null) {
}
}
static setTaxValuation = ($this, value) => {
var oldValue = $this.TaxValuation;
$this.TaxValuation = value;
if (value != null) {
if (oldValue != null && oldValue.TaxAsset != null) { oldValue.TaxAsset = null; }
if ($this.TaxValuation.TaxAsset !== $this) {
Domain.AssetValuation.setTaxAsset(value, $this);
}
}
}
static setAccountingValuation = ($this, value) => {
var oldValue = $this.AccountingValuation;
$this.AccountingValuation = value;
if (value != null) {
if (oldValue != null && oldValue.AccountingAsset != null) { oldValue.AccountingAsset = null; }
if ($this.AccountingValuation.AccountingAsset !== $this) {
Domain.AssetValuation.setAccountingAsset(value, $this);
}
}
}
static setAssetLocation = ($this, value) => {
var oldValue = $this.AssetLocation;
$this.AssetLocation = value;
if (value != null) {
}
}
static setAssetGroup = ($this, value) => {
var oldValue = $this.AssetGroup;
$this.AssetGroup = value;
if (value != null) {
}
}
static setAssetResponsible = ($this, value) => {
var oldValue = $this.AssetResponsible;
$this.AssetResponsible = value;
if (value != null) {
}
}

static CalculatedDepreciationRate($this: any, type: any): any{if (type == Domain.AssetDepreciationType.TaxBase) {if ($this?.OverrideTaxRate) {return $this?.DepreciationRate;}else {return $this?.TaxDepreciationCategory?.DepreciationRate;}}else {return $this?.AccountingDepreciationCategory?.DepreciationRate;}
}
static Destruct($this: any, units: any): any{let destructionRatio = Joove.Common.safeNumber(units) / Joove.Common.safeNumber($this?.Quantity);
let taxReduction = Joove.Common.safeNumber($this?.TaxValuation?.NonDepreciatedValue) * Joove.Common.safeNumber(destructionRatio);
let accountingReduction = Joove.Common.safeNumber($this?.AccountingValuation?.NonDepreciatedValue) * Joove.Common.safeNumber(destructionRatio);
$this.TaxValuation.AccumulatedDestructionOrSaleValue = Joove.Common.safeNumber($this?.TaxValuation?.AccumulatedDestructionOrSaleValue) + Joove.Common.safeNumber(taxReduction);
$this.AccountingValuation.AccumulatedDestructionOrSaleValue = Joove.Common.safeNumber($this?.AccountingValuation?.AccumulatedDestructionOrSaleValue) + Joove.Common.safeNumber(accountingReduction);
$this.Quantity = Joove.Common.safeNumber($this?.Quantity) - Joove.Common.safeNumber(units);
}
static GainedOwnershipDate($this: any): any{if ($this?.Status != Domain.AssetStatus.Acquired) {return null;}
return $this?.DateAcquired;
}
static GetCodeClassName(): any{return "Asset";
}
static LostOwnershipDate($this: any): any{if ($this?.Status == Domain.AssetStatus.Destructed) {return $this?.DateDestructed;}
if ($this?.Status == Domain.AssetStatus.Sold) {return $this?.DateSold;}
if ($this?.Status == Domain.AssetStatus.Depreciated) {return $this?.DateDepreciated;}
return null;
}
static OwnershipDays($this: any, start: any,end: any): any{let gainedOwnershipDate = Domain.Asset.GainedOwnershipDate($this);
let lostOwnershipDate = Domain.Asset.LostOwnershipDate($this);
if (Domain.DateHelper.IsDateNull(gainedOwnershipDate)) {return 0;}
if (($this?.TaxDepreciationCategory?.MonthStartType == Domain.MonthStartType.NextMonth)) {gainedOwnershipDate = Domain.DateHelper.FirstOfNextMonth(gainedOwnershipDate);}
if (((new Date(gainedOwnershipDate).getTime()) > (new Date(end).getTime()))) {return 0;}
if (((new Date(gainedOwnershipDate).getTime()) < (new Date(start).getTime()))) {gainedOwnershipDate = start;}
if (Domain.DateHelper.IsDateNull(lostOwnershipDate)) {lostOwnershipDate = end;}
if (((new Date(lostOwnershipDate).getTime()) < (new Date(start).getTime()))) {return 0;}
if (((new Date(lostOwnershipDate).getTime()) > (new Date(end).getTime()))) {lostOwnershipDate = end;}
let diff = Joove.Common.dateDiff(lostOwnershipDate, gainedOwnershipDate);
let diffDays = Joove.Common.cast((Joove.Common.safeNumber(diff?.days) + Joove.Common.safeNumber(1)), "number");
return diffDays;
}
static OwnershipFactor($this: any, start: any,end: any,type: any): any{if (type == Domain.AssetDepreciationType.TaxBase) {if ($this?.TaxDepreciationCategory?.PeriodType == Domain.AssetDepreciationPeriodType.Days) {return Joove.Common.safeNumber((parseFloat((Domain.Asset.OwnershipDays($this, start, end)) as any))) / Joove.Common.safeNumber((parseFloat((365) as any)));}else if ($this?.TaxDepreciationCategory?.PeriodType == Domain.AssetDepreciationPeriodType.Months) {return Joove.Common.safeNumber((parseFloat((Domain.Asset.OwnershipMonths($this, start, end, $this?.TaxDepreciationCategory?.MonthThreshold)) as any))) / Joove.Common.safeNumber((parseFloat((12) as any)));}else {throw Error("Unknown period type");}}else {if ($this?.AccountingDepreciationCategory?.PeriodType == Domain.AssetDepreciationPeriodType.Days) {return Joove.Common.safeNumber((parseFloat((Domain.Asset.OwnershipDays($this, start, end)) as any))) / Joove.Common.safeNumber((parseFloat((365) as any)));}else if ($this?.AccountingDepreciationCategory?.PeriodType == Domain.AssetDepreciationPeriodType.Months) {return Joove.Common.safeNumber((parseFloat((Domain.Asset.OwnershipMonths($this, start, end, $this?.AccountingDepreciationCategory?.MonthThreshold)) as any))) / Joove.Common.safeNumber((parseFloat((12) as any)));}else {throw Error("Unknown period type");}}
}
static OwnershipMonths($this: any, start: any,end: any,threshold: any): any{let gainedOwnershipDate = Domain.Asset.GainedOwnershipDate($this);
let lostOwnershipDate = Domain.Asset.LostOwnershipDate($this);
if (Domain.DateHelper.IsDateNull(gainedOwnershipDate)) {return 0;}
if (($this?.TaxDepreciationCategory?.MonthStartType == Domain.MonthStartType.NextMonth)) {gainedOwnershipDate = Domain.DateHelper.FirstOfNextMonth(gainedOwnershipDate);}
if (((new Date(gainedOwnershipDate).getTime()) > (new Date(end).getTime()))) {return 0;}
if (((new Date(gainedOwnershipDate).getTime()) < (new Date(start).getTime()))) {gainedOwnershipDate = start;}
if (Domain.DateHelper.IsDateNull(lostOwnershipDate)) {lostOwnershipDate = end;}
if (((new Date(lostOwnershipDate).getTime()) < (new Date(start).getTime()))) {return 0;}
if (((new Date(lostOwnershipDate).getTime()) > (new Date(end).getTime()))) {lostOwnershipDate = end;}
let fullMonths = Joove.Common.safeNumber((moment(lostOwnershipDate).month() + 1)) + Joove.Common.safeNumber(12) * Joove.Common.safeNumber(moment(lostOwnershipDate).year()) - Joove.Common.safeNumber((moment(gainedOwnershipDate).month() + 1)) - Joove.Common.safeNumber(12) * Joove.Common.safeNumber(moment(gainedOwnershipDate).year()) - Joove.Common.safeNumber(1);
if (CLMS.Framework.Number.Equal(() => fullMonths, () => -1)) {if (CLMS.Framework.Number.GreaterThan(() => Joove.Common.safeNumber(moment(lostOwnershipDate).date()) - Joove.Common.safeNumber(moment(gainedOwnershipDate).date()), () => threshold)) {return 1;}else {return 0;}}
let lostMonth = (CLMS.Framework.Number.GreaterThan(() => moment(lostOwnershipDate).date(), () => threshold) ? 1 : 0);
let gainedMonth = (CLMS.Framework.Number.GreaterThan(() => Joove.Common.safeNumber(30) - Joove.Common.safeNumber(moment(gainedOwnershipDate).date()), () => threshold) ? 1 : 0);
return Joove.Common.safeNumber(gainedMonth) + Joove.Common.safeNumber(lostMonth) + Joove.Common.safeNumber(fullMonths);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}